import { useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import ModalContentWrapper from './ModalContentWrapper'
import ModalMainWrapper from './ModalMainWrapper'
import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalFooter from './ModalFooter'

export default function ConfirmCSVRemove({ onConfirm }) {
    let [, setIsOpen] = useState(true)

    const skimModal = ModalStore((state) => state.skim)

    // function closeModal() {
    //     setIsOpen(false)
    // }

    function openModal() {
        setIsOpen(true)
    }

    function handleConfirm() {
        skimModal()
        onConfirm()
    }

    return (
        <>
            <div className="fixed inset-0 flex items-center justify-center">
                <button
                    type="button"
                    onClick={openModal}
                    className="px-4 py-2 text-sm font-medium text-white bg-black rounded-md bg-opacity-20 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                    Open dialog
                </button>
            </div>

            <ModalMainWrapper zIndexClass="z-[130]">
                <ModalContentWrapper size="md">
                    <ModalHeader title="Confirm CSV Remove" />
                    <ModalContent>
                        <div className="m-3">
                            <p className="text-sm text-gray-500">
                                if you click yes, this file will be deleted and
                                you will have to re-upload.
                            </p>
                        </div>
                        <ModalFooter
                            onCancel={skimModal}
                            onConfirm={handleConfirm}
                        />
                    </ModalContent>
                </ModalContentWrapper>
            </ModalMainWrapper>
        </>
    )
}
